import {
  useTranslate,
  useCustomMutation,
  useNotification,
} from '@refinedev/core';
import { Button, Card, Popconfirm, Space, Typography } from 'antd';
import { ThunderboltOutlined } from '@ant-design/icons';

const { Title, Paragraph } = Typography;

export const SystemToolsPage = () => {
  const t = useTranslate();
  const { open } = useNotification();

  const { mutate: flushCache, mutation: flushMutation } = useCustomMutation();

  const handleFlushCache = () => {
    flushCache(
      {
        url: 'system/redis/cache',
        method: 'delete',
        values: {},
      },
      {
        onSuccess: () => {
          open?.({
            type: 'success',
            message: t('notifications.success'),
            description: t('system.tools.flush_cache.success'),
          });
        },
        onError: () => {
          open?.({
            type: 'error',
            message: t('notifications.error'),
            description: t('system.tools.flush_cache.error'),
          });
        },
      }
    );
  };

  return (
    <div style={{ padding: '24px' }}>
      <Title level={2}>{t('resources.tools')}</Title>

      <Space direction="vertical" size={16} style={{ width: '100%' }}>
        <Card title={t('system.tools.flush_cache.title')}>
          <Paragraph type="secondary">
            {t('system.tools.flush_cache.description')}
          </Paragraph>
          <Popconfirm
            title={t('system.tools.flush_cache.confirm_title')}
            description={t('system.tools.flush_cache.confirm_message')}
            onConfirm={handleFlushCache}
            okText={t('system.tools.flush_cache.button')}
            cancelText={t('actions.cancel')}
            okButtonProps={{ danger: true }}
          >
            <Button
              danger
              icon={<ThunderboltOutlined />}
              loading={flushMutation.isPending}
            >
              {t('system.tools.flush_cache.button')}
            </Button>
          </Popconfirm>
        </Card>
      </Space>
    </div>
  );
};
